import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { DhuttuAuth0Provider } from './auth/Auth0Provider';
import { queryClient } from './api/queryClient';
import { registerErrorHandlers } from './api/registerErrorHandlers';
import { useToastStore } from '@dhuttu/ui';
import '@dhuttu/ui-components/src/theme/theme.css';
import './styles/global.css';
registerErrorHandlers(queryClient, {
  onUnauthorized: () => { window.location.href = '/'; },
  onForbidden: (p) => useToastStore.getState().push({ kind: 'error', title: p?.title ?? 'Forbidden', description: p?.detail }),
});
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <DhuttuAuth0Provider>
      <QueryClientProvider client={queryClient}><App /></QueryClientProvider>
    </DhuttuAuth0Provider>
  </StrictMode>,
);
